export default __webpack_public_path__ + "static/media/fullHistory.fa3e68ca.png";